import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    getDefaultHome(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .post('/lineapi/get_default_home', params)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
